import React, { useEffect, useState } from "react";
import { useFormik, FieldArray } from "formik";
import * as Yup from "yup";

import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import LeadFilterForm from "./LeadFilterForm";
import { resetExtraFilters, setStoreFormValues } from "../../../../store/slices/Leads/LeadsSlice";

const useFilterForm = (setShowform) => {
  const dispatch = useDispatch();

  const {
    franchise,
    startDate,
    endDate,
    lead_type_id
  } = useSelector((state) => state.leads);

  const validationSchema = Yup.object({
    franchise: Yup.object().nullable(),
    startDate: Yup.date().nullable(),
    endDate: Yup.date().nullable(),
    lead_type_id: Yup.object().nullable()
  });

  // Set the initial values based on whether edit is true or false
  const initialValues = {
    franchise: franchise,
    startDate: startDate,
    endDate: endDate,
    lead_type_id: lead_type_id,
  
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      const {
        franchise,
        startDate,
        endDate,
        lead_type_id
      } = values;

      if (
        franchise === "" &&
        startDate === "" &&
        endDate === "" &&
        lead_type_id === ""
      ) {
        toast.error("All fields are empty!", {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      } else {
        setShowform(false);
      }

      if (values) {
        dispatch(setStoreFormValues(values));
      }
    },
  });

  const renderTabContent = () => {
    return (
      <LeadFilterForm
        formik={formik}
        handleResetExtraFilters={handleResetExtraFilters}
      />
    );
  };

  const handleResetExtraFilters = () => {
    dispatch(resetExtraFilters());
    formik.resetForm();
    setShowform(false);
  };

  return {
    formik,
    renderTabContent,
    handleResetExtraFilters,
  };
};

export default useFilterForm;
